var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.15 3.15 0 7 0C10.85 0 14 3.15 14 7C14 10.85 10.85 14 7 14C3.15 14 0 10.85 0 7ZM3.15 7L6.125 9.975L10.85 5.25L9.625 4.025L6.125 7.525L4.375 5.775L3.15 7Z",
    fill: "#1ABC60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckCircle);
export default __webpack_public_path__ + "static/media/success-check-circle.6cd585d4bae0b649f274ced47d97fcff.svg";
export { ForwardRef as ReactComponent };